import { useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router';
import { Card, Heading, Loader, useToast } from '@skf-internal/ui-components-react-legacy';
import ManufacturerForm from './ManufacturerForm';
import { getManufacturerById, updateManufacturer, CreateManufacturerDto } from 'services/api/master-data.service';
import { useEffect, useState } from 'react';

const EditManufacturerPage = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { addToast } = useToast();
  const { id } = useParams<{ id: string }>();
  const [initialValues, setInitialValues] = useState<CreateManufacturerDto | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) {
      getManufacturerById(Number(id))
        .then((res) => {
          setInitialValues(res.data);
          setLoading(false);
        })
        .catch((error: any) => {
          console.error('Failed to fetch manufacturer:', error);
          // Display error message to the user
          addToast({ children: intl.formatMessage({ id: 'masterdata.manufacturer.fetch.failure' }, { message: error.message }), feSeverity: 'error' });
          setLoading(false);
        });
    }
  }, [id]);

  const handleSubmit = async (values: CreateManufacturerDto) => {
    try {
      if (id) {
        await updateManufacturer(Number(id), values);
        addToast({ children: intl.formatMessage({ id: 'masterdata.manufacturer.edit.success' }), feSeverity: 'success' });
        // Redirect to the manufacturer list page after successful update
        navigate('/master-data/manufacturers');
      }
    } catch (error: any) {
      console.error('Failed to update manufacturer:', error);
      // Display error message to the user
      addToast({ children: intl.formatMessage({ id: 'masterdata.manufacturer.edit.failure' }, { message: error.message }), feSeverity: 'error' });
    }
  };

  const handleCancel = () => {
    navigate('/master-data/manufacturers');
  };

  if (loading) {
    return <Loader />;
  }

  if (!initialValues) {
    return <p>{intl.formatMessage({ id: 'masterdata.manufacturer.edit.notFound' })}</p>;
  }

  return (
    <Card className="mb-5">
      <Heading as={'h1'} className="mb-4">
        {intl.formatMessage({ id: 'masterdata.manufacturer.edit.heading' })}
      </Heading>
      <ManufacturerForm initialValues={initialValues} onSubmit={handleSubmit} onCancel={handleCancel} />
    </Card>
  );
};

export default EditManufacturerPage;
